// services/tunnelService.js
import api from "./api";

export const getAllTunnels = async (schemaName = null) => {
  try {
    const response = await api.get("/tunnels/", {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tunnels:", error);
    throw error;
  }
};

export const deleteTunnel = async (tunnelId, schemaName = null) => {
  try {
    const response = await api.delete(`/tunnels/${tunnelId}/`, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error deleting tunnel:", error);
    throw error;
  }
};

export const addTunnel = async (tunnelData, schemaName = null) => {
  try {
    const response = await api.post("/tunnels/", tunnelData, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error adding tunnel:", error);
    throw error;
  }
};

export const getTunnelById = async (tunnelId, schemaName = null) => {
  try {
    const response = await api.get(`/tunnels/${tunnelId}/`, {
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tunnel:", error);
    throw error;
  }
};

export const getTunnelsWithParams = async (params = {}) => {
  try {
    const response = await api.get("/tunnels/", { params });
    return response.data;
  } catch (error) {
    console.error("Error fetching tunnels:", error);
    throw error;
  }
};

export const updateTunnel = async (tunnelId, tunnelData, schemaName = null) => {
  try {
    const response = await api.put(`/tunnels/${tunnelId}/`, tunnelData, {
      maxBodyLength: Infinity, // Keep the large payload support
      params: {
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error updating tunnel:", error);
    throw error;
  }
};

export const getTunnelsBySite = async (siteId, schemaName = null) => {
  try {
    const response = await api.get(`/tunnels/by-site/`, {
      params: {
        site: siteId,
        ...(schemaName && { client: schemaName }),
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching tunnels for site ${siteId}:`, error);
    throw error;
  }
};

// Optional: Add pagination support
export const getTunnelsWithPagination = async ({
  page = 1,
  pageSize = 10,
  search = "",
  siteId = "",
  status = "",
  ordering = "-created_at",
}) => {
  try {
    const params = new URLSearchParams({
      page,
      page_size: pageSize,
      search,
      ordering,
    });

    if (siteId) params.append("site", siteId);
    if (status) params.append("status", status);

    const response = await api.get("/tunnels/", { params });
    return {
      results: response.data.results,
      count: response.data.count,
      next: response.data.next,
      previous: response.data.previous,
    };
  } catch (error) {
    console.error("Error fetching tunnels with pagination:", error);
    throw error;
  }
};

// Optional: Add tunnel status management
export const getTunnelStatus = async (tunnelId) => {
  try {
    const response = await api.get(`/tunnels/${tunnelId}/status/`);
    return response.data;
  } catch (error) {
    console.error("Error fetching tunnel status:", error);
    throw error;
  }
};

export const updateTunnelStatus = async (tunnelId, statusData) => {
  try {
    const response = await api.put(`/tunnels/${tunnelId}/status/`, statusData);
    return response.data;
  } catch (error) {
    console.error("Error updating tunnel status:", error);
    throw error;
  }
};

// Optional: Add bulk operations
export const bulkCreateTunnels = async (tunnelsData) => {
  try {
    const response = await api.post("/tunnels/bulk-create/", tunnelsData);
    return response.data;
  } catch (error) {
    console.error("Error bulk creating tunnels:", error);
    throw error;
  }
};

export const bulkUpdateTunnels = async (tunnelsData) => {
  try {
    const response = await api.put("/tunnels/bulk-update/", tunnelsData);
    return response.data;
  } catch (error) {
    console.error("Error bulk updating tunnels:", error);
    throw error;
  }
};

// Optional: Add tunnel metrics
export const getTunnelMetrics = async (tunnelId, timeframe = "day") => {
  try {
    const response = await api.get(`/tunnels/${tunnelId}/metrics/`, {
      params: { timeframe },
    });
    return response.data;
  } catch (error) {
    console.error("Error fetching tunnel metrics:", error);
    throw error;
  }
};
